import React from 'react'
import { Topo } from 'common/styleguide/Topo'
import { SectionBox } from 'common/styleguide/SectionBox'
import { CalendarDate } from 'common/styleguide/CalendarDate'
import { NoticeBar } from 'common/styleguide/NoticeBar'
import { Chip } from 'common/styleguide/Chip'
import { Accordion, AccordionItem } from 'common/styleguide/Accordion'
import styles from './Widgets.scss'
import { interfaceBase } from 'lib/styleguide/base.scss'
import cx from 'classnames'

export class Widgets extends React.PureComponent {
  render () {
    return (
      <div className={styles.Widgets}>
        <h1>Widgets</h1>
        <h2>Topo Background</h2>
        <Topo>
          <div className={styles.topoInner}>Topo Light</div>
        </Topo>
        <Topo dark>
          <div className={styles.topoInner}>Topo Dark</div>
        </Topo>
        <Topo mint>
          <div className={styles.topoInner}>Topo Mint</div>
        </Topo>
        <h2>SectionBox</h2>
        <div className={cx(styles.demoBox, interfaceBase)}>
          <SectionBox title='SectionBox Title'>
            <p>
              Ellen Noble est une cycliste américaine, née le 3 décembre 1995 à Kennebunkport dans le Maine. Elle est spécialiste du cyclo-cross et est membre depuis 2016 de l'équipe américaine Aspire Racing.
            </p>
          </SectionBox>
          <SectionBox title='SectionBox Title'>
            <p>
              Edouard Louis Joseph (Eddy) baron Merckx (Meensel-Kiezegem, 17 juni 1945) is een voormalig Belgisch wielrenner. Hij was actief van 1961 tot 1978. Na die tijd richtte hij een fietsenbedrijf op genaamd Eddy Merckx. Hij staat met 525 gewonnen wedstrijden in de wielersportjournalistiek als de beste wielrenner aller tijden te boek. Het Franse tijdschrift Vélo betitelde hem in 2000 als "de grootste ooit in het wielrennen"
            </p>
          </SectionBox>
        </div>
        <h2>CalendarDate</h2>
        <div style={{ marginBottom: '40px' }}>
          <CalendarDate date={new Date()} />
        </div>

        <h2>NoticeBar</h2>
        <div style={{ marginBottom: '40px' }}>
          <NoticeBar>
            Pssst... You're getting a sneak peek of our new Route page. Click <a href='#'>here</a> to go back to the regular Route page.
            <br />You can opt out of the beta at any time in your <a href='/settings/labs' target='_blank'>user settings</a>.
          </NoticeBar>
        </div>

        <h2>Chip</h2>
        <div style={{ marginBottom: '40px' }}>
          <Chip>Default Chip</Chip><Chip onDismiss={() => {}}>Dismissable Chip</Chip>
        </div>

        <h2>Accordion</h2>
        <p>Only one item can be expanded in a standard Accordion</p>
        <div style={{ maxWidth: '400px', marginBottom: '40px' }}>
          <Accordion>
            <AccordionItem title='Two satellites decided to get married...'>
              The wedding wasn't much, but the reception was incredible!
            </AccordionItem>
            <AccordionItem title='What do sprinters eat before a race?'>
              Nothing, they fast.
            </AccordionItem>
            <AccordionItem title='It has four legs and it can fly, what is it?'>
              Two birds.
            </AccordionItem>
          </Accordion>
        </div>

        <p>Multiple items can be expanded in an Accordion with the multi prop</p>
        <div style={{ maxWidth: '400px', marginBottom: '40px' }}>
          <Accordion multi>
            <AccordionItem title='Two satellites decided to get married...'>
              The wedding wasn't much, but the reception was incredible!
            </AccordionItem>
            <AccordionItem title='What do sprinters eat before a race?'>
              Nothing, they fast.
            </AccordionItem>
            <AccordionItem title='It has four legs and it can fly, what is it?'>
              Two birds.
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    )
  }
}
